module.exports = __webpack_public_path__ + "static/img/14000527.5be676b9.png";